import {
    clearKeyword,
    clearSelection,
    setKeyword,
    setPage,
    setPageSize,
} from '../reducers';

import {
    selectionSelector,
    selectVisibility,
    visibilityStateSelector,
} from '../selectors';

import {columns} from '../tables/columns';
import {
    useAppDispatch,
    useAppSelector
} from '../../../hooks/useTypedReactRedux';

import {
    useDeleteTopLevelDomainMutation,
    useTopLevelDomainsQuery
} from './useTopLevelDomainsQuery';

// FNP-944: records come from React Query; selection, paging and keyword stay in
// Redux. Return shape unchanged so the table, buttons, inputs and the dashboard
// widget consuming this hook did not change.
export const useTopLevelDomains = () => {

    const dispatch = useAppDispatch();

    const selection = useAppSelector((state) => selectionSelector(state));
    const visibility = useAppSelector((state) => visibilityStateSelector(state));

    const {
        data,
        isLoading,
        refetch
    } = useTopLevelDomainsQuery();

    const deleteMutation = useDeleteTopLevelDomainMutation();

    const {
        items,
        visibleItems,
        limit,
        keyword,
        page,
        totalPages,
        visibleCount,
    } = selectVisibility(visibility, data ?? []);

    // FETCH
    const fetchRecords = () => {
        refetch();
    };

    const deleteRecords = () => {
        if (Object.keys(selection).length > 0) {
            for (const key in selection) {
                deleteMutation.mutate(key);
            }
            // Clear the checkboxes once the deletions are issued - otherwise the
            // selection keeps naming records that no longer exist.
            dispatch(clearSelection());
        }
    };


    // FILTERING AND PAGING
    const handleFilterByKeyword = (keyword: string) => {
        if (keyword !== '') {
            dispatch(setKeyword(keyword));
        } else {
            dispatch(clearKeyword());
        }
    };

    const handleItemsPerPageChange = (pageSize: string | null) => {
        dispatch(setPageSize(pageSize));
    };

    const handlePageChange = (page: number) => {
        dispatch(setPage(page));
    };

    // BATCH ACTIONS
    const handleBatchActionCancel = () => {
        dispatch(clearSelection());
    };

    return {
        items,
        visibleItems,
        limit,
        loading: isLoading,
        keyword,
        page,
        totalPages,
        visibleCount,
        columns,
        fetchRecords,
        deleteRecords,
        handleFilterByKeyword,
        handleItemsPerPageChange,
        handleBatchActionCancel,
        handlePageChange,
    };
};
